import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Lock } from 'lucide-react';
import NoIndex from '../components/NoIndex';

const formatError = (detail) => {
  if (!detail) return 'Er ging iets mis. Probeer het opnieuw.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return String(detail);
};

const AdminLogin = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  React.useEffect(() => {
    if (user) navigate('/admin', { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen pt-20 flex items-center justify-center bg-gray-50 px-4">
      <NoIndex />
      <div className="w-full max-w-md bg-white rounded-2xl shadow-elegant p-8 border border-gray-100">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-full bg-cm-primary flex items-center justify-center mb-4">
            <Lock className="text-white" size={26} />
          </div>
          <h1 className="text-3xl font-light text-cm-primary">Admin Inloggen</h1>
          <p className="text-sm text-gray-500 mt-2">Beheer kleuren, teksten, cocktails en offertes</p>
        </div>

        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-sm text-gray-700 mb-2">E-mail</label>
            <input
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:border-cm-primary focus:ring-1 focus:ring-cm-primary outline-none"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-2">Wachtwoord</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:border-cm-primary focus:ring-1 focus:ring-cm-primary outline-none"
              data-testid="admin-login-password"
            />
          </div>
          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg p-3" data-testid="admin-login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full btn-primary disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {busy ? 'Bezig...' : 'Inloggen'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
